//@ts-ignore
import * as initials from "initials";
import { IFormsState } from "../../store/forms/types";
import { IFieldBoomformInitials } from "../../store/fields/initails";

export const fieldsInitials: IFieldBoomformInitials = initials["default"]["fieldsInitials"];
export const formInitials: IFormsState = initials["default"]["formInitials"];
